exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.temp-redirect[data-v-7376f882] {\n  padding: 50px;\n  text-align: center;\n  color: #606266;\n}\n", ""]);

// exports
